import { render, staticRenderFns } from "./IncomeStatement-2.vue?vue&type=template&id=7f32d01b"
import script from "./IncomeStatement-2.vue?vue&type=script&lang=js"
export * from "./IncomeStatement-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports